import EcommerceSignalSubType from "./EcommerceSignalSubType";

export const ECOMMERCE_CHANGE_SUBTYPES = new Set<string>([
    EcommerceSignalSubType.OnlineRevenueChange,
    EcommerceSignalSubType.OnlineTransactionsChange,
]);
